import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'
import MyRichText from '../../../components/forms/richText'
import MyColumnSelect from '../../../components/select/columnSelect'

const AddFaq = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.question) {
      setErrorMsg({questionEmpty: '问题不能为空'})
      return false
    }
    if (!formValue.column_oid) {
      setErrorMsg({columnEmpty: '所属栏目不能为空'})
      return false
    }

    axios.post('/p/content/faq/add', {
      merchant_oid: merchantOid,
      question: formValue.question,
      column_oid: formValue.column_oid,
      answer: formValue.answer,
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('新常见问题创建成功！')
          props.getFaqList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({column_oid: formValue.column_oid})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <>
      <Modal
        destroyOnClose={true}
        title="创建常见问题"
        width='800px'
        open={props.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key='cancel' onClick={handleCancel}>取消</Button>,
          <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
          <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
        ]}>

        <MyColumnSelect
          id='column_oid'
          required
          label='选择栏目'
          category={5}
          value={formValue.column_oid}
          onChange={setFormValue}
          errorMsg={errorMsg.columnEmpty}
        />

        <MyInput
          id="question"
          required
          autoFocus
          maxLength={64}
          label='问题'
          placeholder='请输入文章的标题'
          value={formValue.question}
          onChange={setFormValue}
          errorMsg={errorMsg.questionEmpty}
        />

        <MyRichText
          id='answer'
          required
          label='答案'
          value={formValue.answer}
          setValue={setFormValue}
        />

        <MyInput
          type='number'
          id="sort"
          label='排序'
          value={formValue.sort}
          onChange={setFormValue}
          styles={{ width: '60px' }}
          min={0}
          max={1000}
        />
      </Modal>
    </>
  )
}

export default AddFaq
